import React, { useCallback } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import CommonCard from 'Components/new/common-card'

interface IProps {
  order?: number
  category: string
  className?: string
  uniqueIdStr: string
  title: string
  coverUrl: string
  duration: number
  avatar: string
  name: string
  videoWatchCount: number
  publishTime: number
  userId: string
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  order,
  category,
  uniqueIdStr,
  title,
  coverUrl,
  duration,
  avatar,
  name,
  userVerified,
  verifyType,
  userId,
  videoWatchCount,
  publishTime,
  authorTeaParams,
  contentTeaParams,
}) => {
  const handleClick = useCallback(() => {
    if (!contentTeaParams) {
      return
    }
    sendTeaCommEvent(
      'clk_event',
      Object.assign(
        {
          category_name: category,
          group_id: uniqueIdStr,
          rank: `${order}`,
        },
        contentTeaParams
      )
    )
  }, [uniqueIdStr, category, order, contentTeaParams])

  return (
    <CommonCard
      collectVisible={false}
      id={uniqueIdStr}
      articleType={duration ? 2 : 1}
      title={title}
      watchCount={videoWatchCount}
      publishTime={publishTime}
      duration={duration}
      coverUrl={coverUrl}
      avatar={avatar}
      username={name}
      verifyType={verifyType}
      userVerified={userVerified}
      userId={userId}
      onClick={handleClick}
      zt="feed"
      onClickUser={() => {
        if (!authorTeaParams) {
          return
        }
        sendTeaCommEvent(
          'clk_event',
          Object.assign(
            {
              category_name: category,
              group_id: uniqueIdStr,
              user_id: `${userId}`,
            },
            authorTeaParams
          )
        )
      }}
    />
  )
}

export default Item
